import { compose, lifecycle, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getTireSizeCount } from '../helpers'
import { setTireSizeNumber } from '../actions'
import { getHasActiveVehicleStatus } from 'selectors'
import { getActiveVehicleName, getActiveVehicleTireSize } from 'selectors/getActiveVehicle'
import BOTTireSizeDetails from './BOTTireSizeDetailsCartridge'

const mapStateToProps = state => ({
  activeVehicleName: getActiveVehicleName(state),
  activeVehicleHasNoTireSize: getHasActiveVehicleStatus(state) ? !getActiveVehicleTireSize(state) : false
})

export default compose(
  withType({ type: 'BOTTireSizeDetailsCartridge' }),
  connect(mapStateToProps, { setTireSizeNumber }),
  withProps(({ activeVehicleHasNoTireSize, compartibleTireSizes = []}) =>
    ({ showShopEligibleTires: !activeVehicleHasNoTireSize && !compartibleTireSizes.length })),
  lifecycle({
    componentDidMount() {
      this.props.setTireSizeNumber(getTireSizeCount(this.props.compartibleTireSizes))
    }
  })
)(BOTTireSizeDetails)
